import { useContext } from 'react';
import { get } from 'lodash-es';
import { GlobalSettingsContext } from '../context/GlobalSettingsProvider';

/**
 * Hook k získání globálního nastavení aplikace
 * @param key klíč do hash nastavení - omezuje jaká část stromu se vrací
 * @param defaultValue výchozí hodnota, pokud není nastavení nalezeno
 */
export const useNastaveni = <T extends unknown>(
  key: string,
  defaultValue?: T
): [T, (data: T) => void] => {
  const globalSettingsContext = useContext(GlobalSettingsContext);
  if (!globalSettingsContext.initByProvider) {
    throw new Error(
      'Použití useNastaveni vyžaduje obalení aplikace pomací GlobalSettingsProvider'
    );
  }

  return [
    get(globalSettingsContext.data, key) || defaultValue,
    // @ts-ignore
    value => globalSettingsContext.setNastaveni(key, value),
  ];
};
